export function useWaitingRequest<T> () {
  let waitingPromises: { resolve: (value: T) => void; reject: (reason?: unknown) => void }[] = []
  let isFetching = false

  const execute = async (fetchFn: () => Promise<T>): Promise<T> => {
    if (isFetching) {
      return new Promise((resolve, reject) => {
        waitingPromises.push({ resolve, reject })
      })
    }

    try {
      isFetching = true
      const result = await fetchFn()

      waitingPromises.forEach(promise => promise.resolve(result))
      waitingPromises = []

      return result
    } catch (e) {
      waitingPromises.forEach(promise => promise.reject(e))
      waitingPromises = []
      throw e
    } finally {
      isFetching = false
    }
  }

  const reset = () => {
    waitingPromises = []
    isFetching = false
  }

  return {
    execute,
    reset,
    get isPending () {
      return isFetching
    },
  }
}
